import { SUPPORT_EMAIL } from '../../store/UIStore'
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { AccountOnboardingLayout } from '../../containers/AccountOnboardingLayout'

function AddInstagramErrorPage() {
    return (
        <AccountOnboardingLayout
            title="Couldn't add your Instagram profile"
            tabTitle="Instagram error"
            subtitle="Check the details below, then try again."
        >
            <div className="max-w-2xl">
                <p className="text-lg font-medium text-ink-900">
                    Please check that the following statements are true
                </p>
                <ul className="mt-4 space-y-3 text-ink-700">
                    <li className="flex items-start">
                        <CheckCircleIcon className="mr-2 h-6 w-6 flex-none text-ink-400" />
                        <span>The Instagram account you selected is a Business account</span>
                    </li>
                    <li className="flex items-start">
                        <CheckCircleIcon className="mr-2 h-6 w-6 flex-none text-ink-400" />
                        <span>The Facebook page is linked to your Instagram account</span>
                    </li>
                    <li className="flex items-start">
                        <CheckCircleIcon className="mr-2 h-6 w-6 flex-none text-ink-400" />
                        <span>
                            If you have multiple pages and Instagram accounts please make sure you
                            selected the correct combination
                        </span>
                    </li>
                </ul>
                <p className="mt-6 text-ink-700">
                    If none of this works then please refer to{' '}
                    <a
                        href="https://knowledge.arwen.ai/how-to-connect-primary-to-your-instagram-account"
                        target="_blank"
                        rel="noreferrer"
                        className="text-arwen-600 underline hover:text-arwen-800"
                    >
                        our support pages
                    </a>{' '}
                    for further assistance.
                </p>
                <div className="mt-8 flex flex-wrap gap-3">
                    <a
                        href="/"
                        className="inline-flex items-center justify-center rounded-md bg-arwen-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-arwen-700 focus:outline-none focus:ring-2 focus:ring-arwen-500 focus:ring-offset-2"
                    >
                        Try again
                    </a>
                    <a
                        href={`mailto:${SUPPORT_EMAIL}`}
                        rel="noreferrer"
                        className="inline-flex items-center justify-center rounded-md border border-ink-200 bg-white px-5 py-2.5 text-sm font-medium text-ink-700 hover:bg-ink-50 focus:outline-none focus:ring-2 focus:ring-arwen-500 focus:ring-offset-2"
                    >
                        Contact Customer Support
                    </a>
                </div>
            </div>
        </AccountOnboardingLayout>
    )
}

export default AddInstagramErrorPage
